
    (function () {
      // ====== CONFIG ======
      // Target *this* variant-picker; change to simply 'variant-picker' if you want it global.
      var CONTAINER_SEL = 'variant-picker.variant-picker';

      // Optional: lock to specific legends (safer if there are other "Size" groups on the page).
      var GROUP_LABELS = [
        //'Deluxe Bed Base (Bedding size)',
        //'Sleep Republic Deluxe Lines Bedhead (Bedding size)',
        // 'Third Group (Bedding size)',
        // 'Fourth Group (Bedding size)'
      ];

      // Optional per-group value maps (canonical -> group value).
      // Leave as {} when labels are identical across groups (Single/Double/Queen/King).
      var VALUE_MAPS = { 0: {}, 1: {}, 2: {}, 3: {} };

      // Mark radios/labels that WE "disable" so we don't treat them as theme-disabled
      var MIRROR_ATTR = 'data-bundlesync-mirrored';
      var MIRROR_LABEL_CLASS = 'bundle-sync-disabled';

      // ====== HELPERS ======
      function $container() {
        var $c = $(CONTAINER_SEL).first();
        return $c.length ? $c : null;
      }

      function legendText($fs) {
        var $lg = $fs.find('legend').first();
        return $.trim($lg.text() || '');
      }

      function findFieldsets($root) {
        var $sets = $root.find('fieldset.variant-option');

        // Prefer explicit GROUP_LABELS if provided
        if (GROUP_LABELS.length) {
          var out = [];
          var lowers = GROUP_LABELS.map(function (s) { return (s || '').toLowerCase(); });

          $sets.each(function () {
            var $fs = $(this);
            var txt = legendText($fs).toLowerCase();
            lowers.forEach(function (needle, idx) {
              if (!out[idx] && needle && txt.indexOf(needle) > -1) out[idx] = $fs;
            });
          });

          return out.filter(Boolean).slice(0, 4);
        }

        // Fallback: any legend containing "Bedding size"
        var list = $sets.filter(function () {
          return /bedding\s*size/i.test(legendText($(this)));
        }).toArray().map(function (el) { return $(el); });

        return list.slice(0, 4);
      }

      function radiosInFieldset($fs) {
        return $fs.find('input[type=radio]');
      }

      function getVal($group) {
        var $c = $group.filter(':checked');
        return $c.length ? $.trim($c.val() || '') : '';
      }

      function hasVal($group, val) {
        val = $.trim(val);
        var found = false;
        $group.each(function () {
          if ($.trim(this.value) === val) { found = true; return false; }
        });
        return found;
      }

      function isSelectable($radio) {
        // Theme uses aria-disabled + data-option-available; disabled attr may not be used.
        var aria = ($radio.attr('aria-disabled') || '').toLowerCase();
        if (aria === 'true') return false;

        var ava = $radio.attr('data-option-available');
        if (typeof ava !== 'undefined' && String(ava).toLowerCase() === 'false') return false;

        // Also honor native disabled if present
        if ($radio.is(':disabled')) return false;

        // If we mirrored-disable it, treat as unselectable
        if ($radio.attr(MIRROR_ATTR) === 'true') return false;

        return true;
      }

      function setVal($group, val) {
        val = $.trim(val);
        var $t = $group.filter(function () { return $.trim(this.value) === val; });
        if (!$t.length) return false;
        if (!isSelectable($t)) return false;
        if ($t.prop('checked')) return false;      // skip redundant click (prevents loops)
        $t.trigger('click');                        // let theme handle state/url/etc.
        return true;
      }

      // Canonical mapping helpers
      function toCanonical(idx, groupVal) {
        groupVal = (groupVal || '').trim();
        var m = VALUE_MAPS[idx] || {};
        var inv = {};
        Object.keys(m).forEach(function (can) { inv[(m[can] || '').trim()] = can; });
        return inv[groupVal] || groupVal;
      }

      function fromCanonical(idx, canonical) {
        canonical = (canonical || '').trim();
        var m = VALUE_MAPS[idx] || {};
        return Object.prototype.hasOwnProperty.call(m, canonical) ? m[canonical] : canonical;
      }

      // ====== CSS (to block clicks on mirrored disabled) ======
      function injectCSSOnce() {
        if (document.getElementById('bundle-sync-css')) return;
        var css = document.createElement('style');
        css.id = 'bundle-sync-css';
        css.textContent = `
          ${CONTAINER_SEL} label.variant-option__button-label.${MIRROR_LABEL_CLASS} {
            pointer-events: none;
            opacity: 0.55;
            position: relative;
          }
          ${CONTAINER_SEL} label.variant-option__button-label.${MIRROR_LABEL_CLASS}::after {
            content: "";
            position: absolute;
            left: 8px;
            right: 8px;
            top: 50%;
            height: 1px;
            transform: rotate(-25deg);
            background: currentColor;
            opacity: 0.75;
          }
        `;
        document.head.appendChild(css);
      }

      // ====== GROUP COLLECTION ======
      var isSyncing = false;

      function collectGroups($root) {
        var $fsList = findFieldsets($root).slice(0, 4); // up to 4
        return $fsList.map(function ($fs) {
          return { $fs: $fs, $radios: radiosInFieldset($fs) };
        });
      }

      // ====== DISABLE MIRRORING (integrated) ======
      function isThemeUnavailableRadio($radio) {
        // Ignore radios we disabled ourselves
        if ($radio.attr(MIRROR_ATTR) === 'true') return false;

        var ava = $radio.attr('data-option-available');
        if (typeof ava !== 'undefined' && String(ava).toLowerCase() === 'false') return true;

        var aria = ($radio.attr('aria-disabled') || '').toLowerCase();
        if (aria === 'true') return true;

        // Some themes may also use disabled attribute
        if ($radio.is(':disabled')) return true;

        return false;
      }

      function clearMirroredDisable($radio) {
        if ($radio.attr(MIRROR_ATTR) !== 'true') return;

        $radio.removeAttr(MIRROR_ATTR);
        $radio.closest('label.variant-option__button-label').removeClass(MIRROR_LABEL_CLASS);

        // IMPORTANT: don't forcibly set available=true.
        // Theme may legitimately keep it unavailable; we only remove our UI block.
      }

      function applyMirroredDisable($radio) {
        $radio.attr(MIRROR_ATTR, 'true');

        // Mirror the theme's own disable signals
        $radio.attr('data-option-available', 'false');
        $radio.attr('aria-disabled', 'true');

        $radio.closest('label.variant-option__button-label').addClass(MIRROR_LABEL_CLASS);
      }

      function syncDisabledStates($root) {
        var groups = collectGroups($root);
        if (groups.length < 2) return;

        // 1) Remove previous mirrored disables (fresh recompute)
        groups.forEach(function (g) {
          g.$radios.each(function () {
            clearMirroredDisable($(this));
          });
        });

        // 2) Build canonical -> unavailable map using theme's real unavailable flags
        var unavailable = {};
        groups.forEach(function (g, idx) {
          g.$radios.each(function () {
            var $r = $(this);
            var v = $.trim($r.val() || '');
            if (!v) return;

            var canonical = toCanonical(idx, v);
            if (!canonical) return;

            if (isThemeUnavailableRadio($r)) unavailable[canonical] = true;
          });
        });

        // 3) Apply mirrored disables everywhere for those canonicals
        groups.forEach(function (g, idx) {
          g.$radios.each(function () {
            var $r = $(this);
            var v = $.trim($r.val() || '');
            if (!v) return;

            var canonical = toCanonical(idx, v);
            if (unavailable[canonical]) applyMirroredDisable($r);
          });
        });
      }

      function syncDisabledStatesSoon() {
        var $root = $container();
        if (!$root || !$root.length) return;

        // run now
        syncDisabledStates($root);

        // run again after theme updates / re-render
        setTimeout(function () {
          var $r2 = $container();
          if ($r2 && $r2.length) syncDisabledStates($r2);
        }, 120);
      }

      // ====== CORE SYNC (your existing selection sync, integrated) ======
      function initialAlign($root) {
        var groups = collectGroups($root);
        if (groups.length < 2) return;

        // pick the first group that already has a value
        var masterIdx = -1, canonical = '';
        groups.forEach(function (g, idx) {
          if (masterIdx !== -1) return;
          var v = getVal(g.$radios);
          if (v) { masterIdx = idx; canonical = toCanonical(idx, v); }
        });
        if (masterIdx === -1) return;

        isSyncing = true;
        groups.forEach(function (g, idx) {
          var want = fromCanonical(idx, canonical);
          if (!want) return;
          if (getVal(g.$radios) !== want && hasVal(g.$radios, want)) {
            setVal(g.$radios, want);
          }
        });
        setTimeout(function () { isSyncing = false; }, 30);

        // Ensure disable mirror is correct after initial alignment
        syncDisabledStatesSoon();
      }

      function onAnyChange(e) {
        if (isSyncing) return;
        var $t = $(e.target);
        if (!$t.is('input[type=radio]')) return;

        var $root = $container();
        if (!$root || !$root.length) return;

        var groups = collectGroups($root);
        if (groups.length < 2) return;

        // which group did the change happen in?
        var srcIdx = -1;
        groups.forEach(function (g, idx) {
          if (srcIdx !== -1) return;
          if ($.contains(g.$fs.get(0), $t.get(0))) srcIdx = idx;
        });
        if (srcIdx === -1) return;

        var src = groups[srcIdx];
        var srcVal = getVal(src.$radios);
        if (!srcVal) return;

        var canonical = toCanonical(srcIdx, srcVal);

        isSyncing = true;
        groups.forEach(function (g, idx) {
          if (idx === srcIdx) return;
          var want = fromCanonical(idx, canonical);
          if (!want) return;

          // If already matching, nothing to do
          if (getVal(g.$radios) === want) return;

          // Only set if that value exists and is selectable in the dest group
          if (hasVal(g.$radios, want)) setVal(g.$radios, want);
        });
        setTimeout(function () { isSyncing = false; }, 30);

        // After selection sync, mirror-disable the same sizes
        syncDisabledStatesSoon();
      }

      // ====== BOOT ======
      function boot() {
        if (!window.jQuery) { console.warn('[VariantSync N] jQuery not found.'); return; }

        injectCSSOnce();

        var $root = $container();
        if (!$root || !$root.length) {
          console.warn('[VariantSync N] container not found:', CONTAINER_SEL);
          return;
        }

        // Clean old handlers if re-run
        $(document).off('.bundleSync');

        // Delegate so it survives dynamic re-renders inside this variant-picker
        $(document).on('change.bundleSync', CONTAINER_SEL + ' input[type=radio]', onAnyChange);

        // One-time align + disable mirror
        initialAlign($root);

        // If your theme re-mounts the picker, re-align on section events (harmless if unused)
        $(document).on(
          'shopify:section:load.bundleSync shopify:section:select.bundleSync shopify:section:deselect.bundleSync shopify:section:unload.bundleSync',
          function () {
            var $c = $container();
            if ($c && $c.length) initialAlign($c);
          }
        );

        // Light MutationObserver to re-apply after DOM changes inside the picker
        var el = $root.get(0);
        if (window.MutationObserver && el) {
          var t;
          var mo = new MutationObserver(function () {
            clearTimeout(t);
            t = setTimeout(function () {
              var $c = $container();
              if ($c && $c.length) {
                // don't force align on every mutation; just re-mirror disables
                syncDisabledStatesSoon();
              }
            }, 80);
          });
          mo.observe(el, { childList: true, subtree: true, attributes: true });
        }

        console.log('[VariantSync N] bedding-size sync + mirror-disable active on', CONTAINER_SEL);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }
    })();